import { render, staticRenderFns } from "./repairDetail.vue?vue&type=template&id=c39e5bc6&scoped=true&"
import script from "./repairDetail.vue?vue&type=script&lang=js&"
export * from "./repairDetail.vue?vue&type=script&lang=js&"
import style0 from "./repairDetail.vue?vue&type=style&index=0&id=c39e5bc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39e5bc6",
  null
  
)

export default component.exports